import { sendEvent } from "@/features/analytics/gtm/event";

type SendMenuResponseTimeEventParams = {
  loadingTimeSec: number;
};

export const useMenuResponseTimeEvent = () => {
  const sendMenuResponseTimeEvent = ({
    loadingTimeSec,
  }: SendMenuResponseTimeEventParams) => {
    sendEvent({
      event: "MENU_RESPONSE_TIME",
      loading_time_sec: loadingTimeSec,
      loading_time_unit: "seconds",
    });
  };

  return { sendMenuResponseTimeEvent };
};
